import { render, staticRenderFns } from "./ClinicDetail.vue?vue&type=template&id=6a7e086a&"
import script from "./ClinicDetail.vue?vue&type=script&lang=js&"
export * from "./ClinicDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports